import { Component } from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

/**
 * Red de seguridad: sin esto, cualquier excepción no capturada durante el
 * render (un script externo roto, un asset que 404, un bug puntual) tumba
 * TODO el árbol de React y deja la pantalla completamente en blanco, sin
 * ninguna pista para el usuario ni para quien tenga que depurarlo — es lo
 * que pasó con el script de Emergent y con el worker de PDF.js. Con este
 * boundary, un fallo así muestra un aviso con el diseño de la app y un
 * botón para recargar, en vez de una pantalla vacía.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturó un error de render:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[color:var(--page-bg)] flex items-center justify-center p-4">
          <div className="card-base max-w-sm w-full text-center space-y-3" data-testid="app-error-boundary">
            <div className="text-rose-700 flex items-center justify-center mx-auto">
              <AlertTriangle className="w-8 h-8" />
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-stone-900">Algo ha ido mal</h2>
              <p className="text-sm text-stone-600 mt-1">
                Ha ocurrido un error inesperado. Recarga la página para continuar.
              </p>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary w-full"
              data-testid="app-error-boundary-reload"
            >
              <RefreshCw className="w-4 h-4" />
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
